import { UIUtil, StringUtil } from 'kuaidong-lib'
import { IMallCourseAddressInfo, IMallCourseCreateOrderForm, IMallCourseSkuInfo, MallCourseType } from 'kuaidong-model'

enum InvoiceType {
  Special = 0,
  General = 1,
  EMPTY = 2, // 未选择
  NOT_NEED = 3, // 不需要
}

enum InvoiceMedium {
  Electronic = 0,
  Paper = 1,
}

enum InvoiceTitleType {
  Individual = 0,
  Enterprise = 1,
}

function invoiceType2Label(type: InvoiceType) {
  switch (type) {
    case InvoiceType.General:
      return '普票'
    case InvoiceType.Special:
      return '专用发票'
  }
}

function invoiceMedium2Label(medium: InvoiceMedium) {
  switch (medium) {
    case InvoiceMedium.Paper:
      return '纸质发票'
    case InvoiceMedium.Electronic:
      return '电子发票'
  }
}

function invoiceTitleType2Label(type: InvoiceTitleType) {
  switch (type) {
    case InvoiceTitleType.Enterprise:
      return '企业'
    case InvoiceTitleType.Individual:
      return '个人'
  }
}

export class CourseCenterService {
  static orderForm: IMallCourseCreateOrderForm
  // static courseAddress: string
  static __productKey = 'mall_course_product'
  static __orderFormKey = 'mall_course_order_form'
  static __orderIdKey = 'mall_course_order_id'

  static product: IMallCourseSkuInfo | null = null
  static showCourseTypeLabel(type: MallCourseType) {
    switch (type) {
      case MallCourseType.OfflineCourse:
        return '线下培训'
      case MallCourseType.OnlineCourse:
        return '线上培训'
      case MallCourseType.Hardware:
        return '智能硬件'
    }
  }

  static isHardware(type: MallCourseType) {
    return type === MallCourseType.Hardware
  }

  static invoiceMedium2Label(medium: InvoiceMedium) {
    switch (medium) {
      case InvoiceMedium.Paper:
        return '纸质发票'
      case InvoiceMedium.Electronic:
        return '电子发票'
    }
  }

  static invoiceType2Label(type: InvoiceType) {
    switch (type) {
      case InvoiceType.General:
        return '普票'
      case InvoiceType.Special:
        return '专用发票'
    }
  }

  static setOrderId(orderId: string | null) {
    if (orderId) {
      // this.orderForm.mall_course_id = orderId
      localStorage.setItem(this.__orderIdKey, orderId)
    } else {
      // this.orderForm.mall_course_id = ''
      localStorage.removeItem(this.__orderIdKey)
    }
  }

  static getOrderId() {
    return localStorage.getItem(this.__orderIdKey)
  }

  static setProduct(product: IMallCourseSkuInfo) {
    this.product = product
    localStorage.setItem(this.__productKey, JSON.stringify(this.product))
    this.setOrderId(null)
  }

  static getProduct() {
    if (this.product) {
      return this.product
    } else {
      const product = localStorage.getItem(this.__productKey)
      if (product) {
        return JSON.parse(product)
      } else {
        return null
      }
    }
  }

  //  添加最终支付提交的表单信息

  static initOrderForm(): IMallCourseCreateOrderForm {
    console.log('initOrderForm')
    this.orderForm = {
      mall_course_id: '',
      sku_id: '',
      count: 1,
      // bill_info: null,
      bill_info: {
        bill_type: InvoiceType.EMPTY,
        bill_medium: InvoiceMedium.Electronic,
        bill_header: '',
        bill_header_body: InvoiceTitleType.Enterprise,
        bill_content: '',
        bill_address: '',
        bill_receiver_name: '',
        bill_receiver_phone: '',
        bill_receiver_email: '',
        bill_tax_id: '',
        bank_of_deposit: '',
        bank_of_deposit_account: '',
        note: '',
      },
      address_info: {
        name: '',
        phone_code: '',
        phone: '',
        province: '',
        city: '',
        region: '',
        detail_address: '',
      },
    }
    return this.orderForm
  }

  public static getOrderForm() {
    return this.orderForm || this.getSavedOrderForm() || this.initOrderForm()
  }

  public static billIsEmpty(orderForm: IMallCourseCreateOrderForm) {
    return orderForm.bill_info.bill_type === InvoiceType.EMPTY
  }

  public static billIsNotNeed(orderForm: IMallCourseCreateOrderForm) {
    return orderForm.bill_info.bill_type === InvoiceType.NOT_NEED
  }

  public static setOrderForm(form: IMallCourseCreateOrderForm) {
    this.orderForm = form
    console.log('setOrderForm', JSON.stringify(this.orderForm))
    localStorage.setItem(this.__orderFormKey, JSON.stringify(this.orderForm))
  }

  public static saveOrderForm() {
    this.setOrderForm(this.orderForm)
  }

  // 从本地存的数据中获取订单信息
  public static getSavedOrderForm(): IMallCourseCreateOrderForm | null {
    const localData = localStorage.getItem(this.__orderFormKey)
    if (localData) {
      try {
        return JSON.parse(localData)
      } catch (e) {
        console.log('getSavedOrderForm error', e)
        console.log('getSavedOrderForm error', localData)
      }
    }
    return null
  }

  public static buildInvoiceTypeOptions() {
    return Object.values(InvoiceType)
      .filter((v) => typeof v === 'number' && v !== InvoiceType.EMPTY && v !== InvoiceType.NOT_NEED)
      .map((v) => ({
        value: v,
        label: invoiceType2Label(v as InvoiceType),
      }))
  }

  public static buildInvoiceTitleTypeOptions() {
    return Object.values(InvoiceTitleType)
      .filter((v) => typeof v === 'number')
      .map((v) => ({
        value: v,
        label: invoiceTitleType2Label(v as InvoiceTitleType),
      }))
  }

  public static buildInvoiceMediumOptions() {
    return Object.values(InvoiceMedium)
      .filter((v) => typeof v === 'number')
      .map((v) => ({
        value: v,
        label: invoiceMedium2Label(v as InvoiceMedium),
      }))
  }
}

export class MallCourseDeliveryAddressService {
  constructor(public model: IMallCourseAddressInfo) {}

  get customer() {
    return `${this.model.name} ${this.model.phone}`
  }

  get regionStr() {
    return [this.model.province, this.model.city, this.model.region].join(' ').trim()
  }

  get hasAddress() {
    return !!this.model.name
  }

  get addressDetails() {
    return `${this.model.province} ${this.model.city} ${this.model.region} ${this.model.detail_address}`
  }

  validate() {
    if (!this.model.name) {
      return UIUtil.checkFailed('请填写收货人')
    }

    if (StringUtil.isIncludedEmoji(this.model.name)) {
      return UIUtil.checkFailed('收货人不能包含表情符号')
    }

    if (!this.model.phone) {
      return UIUtil.checkFailed('请填写手机号码')
    }

    if (!StringUtil.validateChinaMobilePhoneNumber(this.model.phone)) {
      return UIUtil.checkFailed('请填写正确的手机号码')
    }

    if (!this.model.province) {
      return UIUtil.checkFailed('请选择地区')
    }

    if (!this.model.detail_address) {
      return UIUtil.checkFailed('请填写详细地址')
    }

    if (StringUtil.isIncludedEmoji(this.model.detail_address)) {
      return UIUtil.checkFailed('详细地址不能包含表情符号')
    }

    return true
  }
}
